import type { RouteRecordRaw } from 'vue-router'
import { guardHrAlumniAccess, guardHrAccess, guardHrCreateResource, guardHrStatsAccess, guardHrHeadcountAccess, guardResourceProfile, guardSettingsAccess, guardEmployeeOnboardingAccess, guardHrCanSeeWages, guardSignatureCampaignAccess } from '@/config/router/navigationsGuards/guardHr'

const MODULE_NAME = 'HR'
const MODULE_ID = 1

const hrRoutes: Array<RouteRecordRaw> = [
  {
    path: '/hr',
    meta: {
      requiresAuth: true,
    },
    beforeEnter: [guardHrAccess],
    children: [
      {
        path: '',
        name: 'HrBase',
        component: () => import('@/views/hrBase/HrBase.vue'),
        beforeEnter: [],
        meta: {
          titleTranslationKey: 'pageTitle.directory',
        },
      },
      {
        path: 'alumni',
        name: 'HrAlumni',
        component: () => import('@/views/hrBase/AlumniBase.vue'),
        beforeEnter: [guardHrAlumniAccess],
        meta: {
          titleTranslationKey: 'pageTitle.alumniDirectory',
        },
      },
      {
        path: 'new',
        name: 'HrCreate',
        component: () => import('@/views/hrBase/HrCreate.vue'),
        beforeEnter: [guardHrCreateResource],
        meta: {
          titleTranslationKey: 'pageTitle.hrCreate',
        },
      },
      {
        path: 'onboarding',
        name: 'Onboarding',
        component: () => import('@/views/hrBase/HrOnboarding.vue'),
        beforeEnter: [guardEmployeeOnboardingAccess],
        meta: {
          titleTranslationKey: 'pageTitle.onboarding',
        },
      },
      {
        path: 'signature-campaigns',
        name: 'SignatureCampaigns',
        component: () => import('@/views/hrBase/SignatureCampaigns.vue'),
        beforeEnter: [guardSignatureCampaignAccess],
        meta: {
          titleTranslationKey: 'pageTitle.signatureCampaigns',
        },
      },
      {
        path: 'signature-campaigns/:campaignId',
        name: 'SignatureCampaign',
        component: () => import('@/views/hrBase/SignatureCampaign.vue'),
        beforeEnter: [guardSignatureCampaignAccess],
        meta: {
          titleTranslationKey: 'pageTitle.signatureCampaigns',
        },
      },
      {
        path: ':resourceId',
        name: 'EmployeeProfile',
        component: () => import('@/views/hrBase/EmployeeProfile.vue'),
        meta: {
        },
        beforeEnter: [guardResourceProfile],
      },
      {
        path: '/stats',
        name: 'HrStats',
        component: () => import('@/views/hrBase/Stats.vue'),
        meta: {
          titleTranslationKey: 'pageTitle.hrStats',
        },
        beforeEnter: [guardHrStatsAccess],
      },
      {
        path: 'headcount',
        name: 'HrHeadcount',
        component: () => import('@/views/hrBase/Headcount.vue'),
        meta: {
          titleTranslationKey: 'pageTitle.hrHeadcount',
        },
        beforeEnter: [guardHrHeadcountAccess],
      },
      {
        path: 'settings',
        name: 'HrSettings',
        component: () => import('@/views/hrBase/Settings.vue'),
        meta: {
          titleTranslationKey: 'pageTitle.hrSettings',
        },
        beforeEnter: [guardSettingsAccess],
      },
      {
        path: 'wages',
        name: 'HrWages',
        component: () => import('@/views/hrBase/WagesBase.vue'),
        beforeEnter: [guardHrCanSeeWages],
        meta: {
          titleTranslationKey: 'pageTitle.wages',
        },
      },
    ],
  },


  // be carefull to not match resourceId with 'new' or 'stats' or 'settings' or 'alumni'
  // Standalone (not under /hr + guardHrAccess) so users can open their own profile without HR module access.
  {
    path: '/hr/:resourceId',
    name: 'EmployeeProfile',
    component: () => import('@/views/hrBase/EmployeeProfile.vue'),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: [guardResourceProfile],
  },

]

export default hrRoutes.map(route => ({ ...route, meta: { ...route.meta, moduleName: MODULE_NAME, moduleId: MODULE_ID } }))
